export default class Detail {
  constructor(contents) {
    this.contents = contents;
    this.open = this.contents.querySelector('._open');
    this.close = this.contents.querySelector('._close');

    this.setup()
  }

  setup () {
    this.open.addEventListener('click', (event) => {
      this.contents.classList.add("open");
    });
    this.close.addEventListener('click', (event) => {
      this.contents.classList.remove("open");
    });
  }

}